import { FSC } from '@features/ForestOwner/Search/Overview/FSC/FSC'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/fsc')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'FSC',
  },
})

function RouteComponent() {
  return <FSC />
}
